// Public API for the Cohort entity. No orchestrators today.

import * as endpoints from './endpoints';

const CohortService = {
  ...endpoints,
};

export default CohortService;
export type { CohortData } from './endpoints';
